import { computed } from 'vue';
import { useStore } from 'vuex';

export function useLayout() {
  const store = useStore();

  const layoutState = computed(() => ({
    isAuth: store.state.layout === 'auth',
    showSidebar: store.state.is_show_sidebar,
    sidebarSkipTransition: store.state.sidebar_skip_transition,
    menuStyle: store.state.menu_style,
    showSearch: store.state.is_show_search,
    layoutStyle: store.state.layout_style
  }));

  const toggleSidebar = () => {
    store.commit('toggleSideBar', !layoutState.value.showSidebar);
  };

  const toggleSearch = () => {
    store.commit('toggleSearch', !layoutState.value.showSearch);
  };

  return {
    layoutState,
    toggleSidebar,
    toggleSearch
  };
} 